import React, { FC, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { AccountContentContainer } from './style';
import { useLoadTrips } from 'customHooks/useLoadTrips';
import moment from 'moment';
import { DownloadRecept, EditNewIcon, Bin, Magic } from 'assets/icons';
import { Icon } from 'components/Icon';
import { useRecoilState } from 'recoil';
import { cancelBookingModalOpenState, cancelReasonModalOpenState, cancelGroupId, cancelBookingId } from 'states/ModalStates/atoms';
import { useBookingBreakdown } from 'customHooks/useBookingBreakdown';
import StyledButton from 'components/Button';
import Modal from 'components/Modal';
import { bookingsStatuses } from 'constants/constant';
import { EditIconWhite, EditIconWhiteDisabled } from 'assets/icons';

import BookingBannerCompleteYourBooking from 'components/BookingBannerCompleteYourBooking';
import CancelBookingModalBody from '../CancelBookingModalBody';
import CancelReasonModalBody from '../CancelReasonModalBody';

import { useGetBookingGroupStatus } from 'customHooks/useGetBookingGroupStatus';
import { colors } from 'constants/colors';

import GuestInformation from '../GuestInformation';
import { smoothNavigate } from "components/SmoothNavigate";


const debug = false;

const BookingDetailsContent: FC = () => {

  const [openCancelBookingModal, setOpenCancelBookingModal] = useRecoilState(cancelBookingModalOpenState)
  const [openCancelReasonModal] = useRecoilState(cancelReasonModalOpenState)

  const [, setCancelModalGroupId] = useRecoilState(cancelGroupId)
  const [, setCancelModalBookingId] = useRecoilState(cancelBookingId)

  const [isGroupBookingCancelled, setIsGroupBookingCancelled] = useState(false);
  const [isGroupBookingIncomplite, setIsGroupBookingIncomplite] = useState(false);
  const [isGroupBookingCheckedOut, setIsGroupBookingChackedOut] = useState(false);
  const [isGroupBookingCheckedIn, setIsGroupBookingChackedIn] = useState(false);



  const history = useHistory()
  const { trips, loading } = useLoadTrips()
  const { groupId } = useParams<{ groupId: string }>()
  const trip = trips[groupId]

  const breakdown = useBookingBreakdown(trip);



  const { currentGroupBookingStatus } = useGetBookingGroupStatus(groupId);


  useEffect(() => {

    if (debug) {
      console.log("currentGroupBookingStatus: ", currentGroupBookingStatus);
    }

    if (currentGroupBookingStatus === "CANCELLED") {
      setIsGroupBookingCancelled(true);
    }
    else {
      setIsGroupBookingCancelled(false);
    }

    if (currentGroupBookingStatus === "INCOMPLETE") {
      setIsGroupBookingIncomplite(true);
    }
    else {
      setIsGroupBookingIncomplite(false);
    }

    if (currentGroupBookingStatus === "CHECKED_OUT") {
      setIsGroupBookingChackedOut(true);
    }
    else {
      setIsGroupBookingChackedOut(false);
    }

    if (currentGroupBookingStatus === "CHECKED_IN") {
      setIsGroupBookingChackedIn(true);
    }
    else {
      setIsGroupBookingChackedIn(false);
    }

  }, [currentGroupBookingStatus]);


  if (debug) {
    console.log("trip =", trip);
  }

  // Old code with trips
  if (loading || !trip || !breakdown) {
    return (
      <AccountContentContainer>
        <div className="accountBody">
          {/* <div className="loading">Loading...</div> */}
        </div>
      </AccountContentContainer>
    );
  }

  const trip_bills_total = trip.bills?.reduce((sum, bill) => {
    return sum + (bill.total ?? 0);
  }, 0);

  const trip_bills_mat = (trip?.bills || []).reduce((sum: number, bill: any) => {
    return sum + Number(bill?.MAT || 0);
  }, 0);

  const trip_bills_hst = (trip?.bills || []).reduce((sum: number, bill: any) => {
    return sum + Number(bill?.HST || 0);
  }, 0);

  if (debug) {
    console.log("----- BREAKDOWN CHECK -----");

    console.log("[BREAKDOWN] MAT counted =", breakdown.mat.toFixed(2));
    console.log("[BILL] MAT from bill =", Number(trip_bills_mat).toFixed(2));
    console.log("[DELTA] MAT counted - bill =", (breakdown.mat - trip_bills_mat).toFixed(2));

    console.log("[BREAKDOWN] HST counted =", breakdown.hst.toFixed(2));
    console.log("[BILL] HST from bill =", Number(trip_bills_hst).toFixed(2));
    console.log("[DELTA] HST counted - bill =", (breakdown.hst - trip_bills_hst).toFixed(2));

    console.log("[BREAKDOWN] total counted =", breakdown.total.toFixed(2));
    console.log("[BILL] total from bill =", Number(trip_bills_total).toFixed(2));
    console.log("[DELTA] total counted - bill =", (breakdown.total - trip_bills_total).toFixed(2));

    console.log("---------------------------");
  }


  const is_group_booking = trip.bookings.length > 1;

  const bookings = trip.bookings;

  const ModifyRoomDates = (booking_id: string) => {
    if (debug) {
      console.log('booking_id = ' + booking_id);
    }
    smoothNavigate(history, `/account/bookings/modify-dates/${groupId}/${booking_id}`)
    //history.push(`/account/bookings/modifyDates/${groupId}/${booking_id}`);
  };

  const ModifyRoomType = (booking_id: string, room_id: string) => {
    if (debug) {
      console.log('booking_id =', booking_id);
      console.log('room_id =', room_id);
    }
    smoothNavigate(history, `/account/bookings/modify-room-type/${groupId}/${booking_id}/${room_id}`);
  };


  const compliteBooking = () => {
    smoothNavigate(history, `/account/bookings/add-guest-info/${groupId}/1`)
  };

  const ModifyRoomAddons = (booking_id: string) => {
    if (debug) {
      console.log('booking_id = ' + booking_id);
    }
    smoothNavigate(history, `/account/bookings/add-ons/${groupId}/${booking_id}`)
    //history.push(`/account/bookings/addOns/${groupId}/${booking_id}`);
  };

  const CancelBooking = () => {
    if (is_group_booking) {
      smoothNavigate(history, `/account/bookings/cancel-group-booking/${groupId}`)
    }
    else {
      setCancelModalGroupId(groupId)
      setCancelModalBookingId(trips[groupId].bookings[0]?.bookingId)
      setOpenCancelBookingModal(true)
    }
  };


  const CancelRoom = (bookingId) => {
    setCancelModalBookingId(bookingId)
    setCancelModalGroupId('');
    setOpenCancelBookingModal(true)
  };



  const totalRooms = Object.keys(bookings).length;

  let showRoomNumber = false;
  let cancelBookingText = 'Cancel Booking';

  if (totalRooms > 1) {
    showRoomNumber = true;
    cancelBookingText = 'Cancel Entire Booking';

  }

  if (debug) {
    console.log('totalRooms = ' + totalRooms);
  }

  const roomsArray = Object.keys(bookings).map((index) => {




    let rooomNumber = +index + 1;

    const booking_checkin = moment(bookings[index]?.checkInDate).format("ddd, DD MMM");
    const booking_checkout = moment(bookings[index]?.checkOutDate).format("ddd, DD MMM");


    const trip_confirmation_code = bookings[index]?.reservationCode;



    let booking_status = bookings[index]?.status;
    let allow_booking_modification = false;

    let booking_rateplan = trip.ratePlan?.ratePlan?.title;

    let booking_room_type = bookings[index]?.roomBookings[0].room.roomType.name + " - " + bookings[index]?.roomBookings[0].room.roomType.bed + " " + (bookings[index]?.roomBookings[0].room.roomType.hasWindows ? "w/ window" : "w/ skylight");

    const roomId = bookings[index]?.roomBookings?.[0]?.room?.roomId;

    if (debug) {
      console.log("rate plan:", booking_rateplan);
      console.log("roomId:", roomId);
    }

    let booking_rateplan_off = '';

    const rateChangeValue = trip.ratePlan?.ratePlan?.rateChangeValue ?? 0;

    if (rateChangeValue > 0) {
      booking_rateplan_off = `(${rateChangeValue}% off)`;
    }

    if (booking_status === 'PENDING') {

      allow_booking_modification = true;

      if (!(bookings[index]?.fullName && bookings[index]?.phoneNumber)) {
        booking_status = 'INCOMPLETE';
      }
      else {
        booking_status = 'CONFIRMED';
      }

    }

    let allow_remove = false;

    if ((booking_status !== "CHECKED_OUT") && (booking_status !== "CANCELLED") && (booking_status !== "EXPIRED") && (booking_status !== "CHECKED_IN") && (bookings.length > 1)) {
      allow_remove = true;
    }


    if (debug) {
      console.log("Booking ID for room cancel: ", bookings[index].bookingId);
    }

    const booking_addons = bookings[index].addons
      ? bookings[index].addons
        .map(addon => addon.bookingAddOn?.title || '')
        .filter(title => title) // 
        .join(', ')
      : '';


    return (
      <div className="room" key={rooomNumber}>

        {showRoomNumber && <div className="roomNumber">Room {rooomNumber}</div>}

        <div className="detailsHeader">
          STATUS:{" "}
          <span className={bookingsStatuses[booking_status]?.className || 'checkedIn'}>
            {bookingsStatuses[booking_status]?.text?.toUpperCase()}
          </span>
          {allow_remove && (
            <div className="accountLinkRemove accountLinkRed">
              <Icon width={11} height={13}>
                <Bin />
              </Icon>
              <div
                className="link"
                onClick={() => CancelRoom(bookings[index].bookingId)}
              >
                Remove Room
              </div>
            </div>
          )}
        </div>
        <div className="detailsLarge">
          <span className="detailsTitle">ROOM TYPE</span>{" "}
          <span className="detailsItem">
            {booking_room_type}
          </span>


          <div className={`accountLink ${!allow_booking_modification ? "disabled" : ""}`}>
            <Icon width={14} height={14}>
              <EditNewIcon
                style={{
                  ...(!allow_booking_modification ? { fill: colors.helpBoxBorder, stroke: colors.helpBoxBorder } : {}),
                  cursor: allow_booking_modification ? "pointer" : "not-allowed"
                }}
              />
            </Icon>
            <div
              className="link"
              onClick={
                allow_booking_modification && roomId
                  ? () => ModifyRoomType(bookings[index].bookingId, roomId)
                  : undefined
              }
              style={{
                color: allow_booking_modification && roomId ? colors.hoverBlue : colors.helpBoxBorder,
                cursor: allow_booking_modification && roomId ? "pointer" : "not-allowed",
              }}
            >
              Modify Room
            </div>
          </div>
          <div className="editButtonBox">
            <StyledButton
              disabled={!allow_booking_modification}
              width='162px'
              height='48px'
              className='editButton'
              onClick={
                allow_booking_modification && roomId
                  ? () => ModifyRoomType(bookings[index].bookingId, roomId)
                  : undefined
              }
              startIcon={allow_booking_modification ? <EditIconWhite /> : <EditIconWhiteDisabled />}
            >
              Modify Room
            </StyledButton>
          </div>
        </div>
        <div className="detailsLarge">
          <span className="detailsTitle">CHECK-IN/CHECK-OUT</span>{" "}
          <span className="detailsItem">
            {booking_checkin} - {booking_checkout}
          </span>

          <div className={`accountLink ${!allow_booking_modification ? "disabled" : ""}`}>
            <Icon width={14} height={14}>
              <EditNewIcon
                style={{
                  ...(!allow_booking_modification ? { fill: colors.helpBoxBorder, stroke: colors.helpBoxBorder } : {}),
                  cursor: allow_booking_modification ? "pointer" : "not-allowed"
                }}
              />
            </Icon>
            <div
              className="link"
              onClick={allow_booking_modification ? () => ModifyRoomDates(bookings[index].bookingId) : undefined}
              style={{
                color: allow_booking_modification ? colors.hoverBlue : colors.helpBoxBorder,
                cursor: allow_booking_modification ? "pointer" : "not-allowed",
              }}
            >
              Modify Dates
            </div>
          </div>
          <div className="editButtonBox">
            <StyledButton
              disabled={!allow_booking_modification}
              width='162px'
              height='48px'
              className='editButton'
              onClick={allow_booking_modification ? () => ModifyRoomDates(bookings[index].bookingId) : undefined}
              startIcon={allow_booking_modification ? <EditIconWhite /> : <EditIconWhiteDisabled />}
            >
              Modify Dates
            </StyledButton>
          </div>
        </div>
        <div className="detailsLarge">
          <span className="detailsTitle">CONFIRMATION</span> <span className="detailsItem">{trip_confirmation_code}</span>
        </div>
        <div className="detailsLarge">
          <span className="detailsTitle">EXTRA</span>

          {booking_addons?.trim() && (
            <>
              <span className='detailsItem'>{booking_addons} </span>
            </>
          )}
          

          <div className={`accountLink ${!allow_booking_modification ? "disabled" : ""}`}>
            <Icon width={14} height={14}>
              <EditNewIcon
                style={{
                  ...(!allow_booking_modification ? { fill: colors.helpBoxBorder, stroke: colors.helpBoxBorder } : {}),
                  cursor: allow_booking_modification ? "pointer" : "not-allowed"
                }}
              />
            </Icon>
            <div
              className="link"
              onClick={allow_booking_modification ? () => ModifyRoomAddons(bookings[index].bookingId) : undefined}
              style={{
                color: allow_booking_modification ? colors.hoverBlue : colors.helpBoxBorder,
                cursor: allow_booking_modification ? "pointer" : "not-allowed",
              }}
            >
              Modify Add-Ons
            </div>
          </div>
          <div className="editButtonBox">
            <StyledButton
              disabled={!allow_booking_modification}
              width="182px"
              height="48px"
              className="editButton"
              onClick={() => ModifyRoomAddons(bookings[index].bookingId)}
              startIcon={allow_booking_modification ? <EditIconWhite /> : <EditIconWhiteDisabled />}
            >
              Modify Add-Ons
            </StyledButton>
          </div>
        </div>
        <div className="detailsLarge">
          <span className="detailsTitle">RATE</span>{" "}
          <span className="detailsItem">
            {booking_rateplan} {booking_rateplan_off}
          </span>
        </div>
      </div>
    );
  })


  if (debug) {
    console.log(trip);
    console.log(is_group_booking);
  }


  return (
    <AccountContentContainer>


      <BookingBannerCompleteYourBooking
        groupID={groupId}
      />

      <div className="accountBody">
        <div className="cardContent">
          <div className="topRtLinks">
            {isGroupBookingIncomplite && (
              <div className="compliteBooking" onClick={compliteBooking}>
                <Icon width={16} height={16}>
                  <Magic />
                </Icon>
                <div className="compliteBookingLink">
                  Complete Your Booking
                </div>
              </div>
            )}

            {!isGroupBookingCancelled && !isGroupBookingCheckedOut && !isGroupBookingCheckedIn && (
              <div className="cancelBooking" onClick={CancelBooking}>
                {cancelBookingText}
              </div>
            )}
          </div>


          {roomsArray}
          <div className="detailsLarge breakDown">BREAKDOWN</div>





          <div>
            {breakdown.lines.map((line) => (
              <div
                key={line.key}
                className={`breakDownLine ${line.red ? "breakDownLineRed" : ""}`}
              >
                <div className="breakDownTitle">{line.title}</div>
                <div className="breakDownDots">
                  <div className={line.red ? "dashedLineRed" : "dashedLine"}></div>
                </div>
                <div className="breakDownNumber">
                  {line.amount < 0 ? "-" : ""}${Math.abs(line.amount).toFixed(2)}
                </div>
              </div>
            ))}
          </div>



          <div className="breakDownTotal">
            <div className="breakDownTitle">TOTAL Counted</div>
            <div className="breakDownDots"></div>
            <div className="breakDownNumber">${breakdown.total.toFixed(2)}</div>
          </div>
          <div className="breakDownTotal">
            <div className="breakDownTitle">TOTAL from the bill</div>
            <div className="breakDownDots"></div>
            <div className="breakDownNumber">${Number(trip_bills_total).toFixed(2)}</div>
          </div>



          <div className="downloadReceipt">
            <div className="accountLink">
              <Icon width={17} height={18}>
                <DownloadRecept />
              </Icon>
              <div className="link">Download Receipt - ???</div>
            </div>
          </div>
        </div>


        {is_group_booking && !isGroupBookingCancelled ? (
          <div className='guestInformationBlock'>
            <GuestInformation
              showDone={false}
              processAlerts={false}
            />
          </div>
        ) : null}

      </div>
      <Modal open={openCancelBookingModal} >
        <CancelBookingModalBody />
      </Modal>
      <Modal open={openCancelReasonModal} >
        <CancelReasonModalBody />
      </Modal>




    </AccountContentContainer>
  );
};

export default BookingDetailsContent;
